// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"7cb00ba1","9638":"833073eb"}[chunkId] + ".chunk.css";
};